module.exports = __webpack_public_path__ + "static/media/email.8b066881.svg";